<div class="px-4 py-4">
  <div
    class="relative bg-gradient-to-br from-white to-slate-50 w-full"
  >
    

    <!-- Render Form if defined -->
    @if(playerForm){
      <!-- Single row for the entire form, if you wish. -->
      <form [formGroup]="playerForm" class="grid grid-cols-6 gap-3 w-full">
        
        <z-card style="display: flex; flex-direction: column; height: 100%;">
        <!-- Personal Info -->
        <div class="flex flex-col flex-1">
          <div class="flex items-center mb-1">
            <div class="w-1 h-4 bg-gradient-to-b from-blue-500 to-blue-600 rounded-full mr-2"></div>
            <h3 class="text-[18px] font-bold text-slate-800 tracking-tight uppercase">
              {{ 'common.table.players.popup.personalInfo' | transloco}}
            </h3>
          </div>
          <!-- Name -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'common.firstName' | transloco }}:</span>
            @if(editMode) {
              <input
                z-input
                formControlName="name"
                class="border rounded px-2 py-1 w-full text-sm bg-white"
                [placeholder]="'common.firstName' | transloco"
              />
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ playerForm.get('name')?.value || '—' }}
              </span>
            }
          </div>
          <!-- Surname -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'common.lastName' | transloco }}:</span>
            @if(editMode) {
              <input
                z-input
                formControlName="surname"
                class="border rounded px-2 py-1 w-full text-sm bg-white"
                [placeholder]="'common.lastName' | transloco"
              />
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ playerForm.get('surname')?.value || '—' }}
              </span>
            }
          </div>
          <!-- Birthday -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'common.birthday' | transloco }}:</span>
            @if(editMode) {
              <z-date-picker 
                [value]="playerForm.get('dateOfBirth')?.value" 
                (dateChange)="onDateOfBirthChange($event)" 
                class="w-full" 
                zSize="sm">
              </z-date-picker>
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ formatDate(playerForm.get('dateOfBirth')?.value) || '—' }}
              </span>
            }
          </div>
          
          <!-- Country -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'common.country' | transloco }}:</span>
            @if(editMode) {
              <input
                z-input
                formControlName="country"
                class="border rounded px-2 py-1 w-full text-sm bg-white"
                [placeholder]="'common.country' | transloco"
              />
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ playerForm.get('country')?.value || '—' }}
              </span>
            }
          </div>
          
          <!-- Gender -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'settings.profile.gender.title' | transloco }}:</span>
            @if(editMode) {
              <z-select formControlName="gender" class="w-full" size="sm">
                <z-select-item value="true">{{ 'settings.profile.gender.male' | transloco }}</z-select-item>
                <z-select-item value="false">{{ 'settings.profile.gender.female' | transloco }}</z-select-item>
              </z-select>
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{
                  playerForm.get('gender')?.value !== null && playerForm.get('gender')?.value !== undefined
                    ? ('settings.profile.gender.' +
                      (playerForm.get('gender')?.value === 'true' ? 'male' : 'female') | transloco)
                    : '—'
                }}
              </span>
            }
          </div>
          <!-- Nationality -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'players.withdrawals.popup.nationality' | transloco }}:</span>
            @if(editMode) {
              <input
                z-input
                formControlName="nationality"
                class="border rounded px-2 py-1 w-full text-sm bg-white"
                [placeholder]="'players.withdrawals.popup.nationality' | transloco"
              />
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ playerForm.get('nationality')?.value || '—' }}
              </span>
            }
          </div>
          <!-- Document Number -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'players.withdrawals.popup.documentNumber' | transloco}}:</span>
            @if(editMode) {
              <input
                z-input
                formControlName="documentNumber"
                class="border rounded px-2 py-1 w-full text-sm bg-white"
                [placeholder]="'players.withdrawals.popup.documentNumber' | transloco"
              />
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ playerForm.get('documentNumber')?.value || '—' }}
              </span>
            }
          </div>
          <!-- Affiliate -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'players.withdrawals.kyc.affiliate' | transloco}}:</span>
            <span class="text-black font-semibold ml-1 text-[13px]">
              {{ getAffiliateDisplay() }}
            </span>
          </div>
          <!-- Referral URL -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'players.withdrawals.kyc.referralUrl' | transloco}}:</span>
            <span class="text-black font-semibold ml-1 text-[13px]">
              {{ playerForm.get('referralUrl')?.value || '—' }}
            </span>
          </div>
          <!-- Creation Date -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'players.withdrawals.kyc.signUpDate' | transloco}}:</span>
            <span class="text-black font-semibold ml-1 text-[13px]">
              {{ formatDate(playerForm.get('creationDate')?.value) || '—' }}
            </span>
          </div>
          <!-- Last Login Date -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'players.withdrawals.kyc.lastLoginDate' | transloco}}:</span>
            <span class="text-black font-semibold ml-1 text-[13px]">
              {{ formatDate(financial_details?.overallFinancialDetails?.lastLoginDate) || '—' }}
            </span>
          </div>
        </div>
        </z-card>
        

        <!-- Contact + Account Info -->
        <z-card>
        <div class="flex flex-col flex-1">
          <div class="flex items-center mb-1">
            <div class="w-1 h-4 bg-gradient-to-b from-emerald-500 to-emerald-600 rounded-full mr-2"></div>
            <h3 class="text-[18px] font-bold text-slate-800 tracking-tight uppercase">
              {{ 'common.table.players.popup.contactInfo' | transloco }}
            </h3>
          </div>
          <!-- Email -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'common.email' | transloco }}:</span>
            @if(editMode) {
              <input
                z-input
                formControlName="email"
                class="border rounded px-2 py-1 w-full text-sm bg-white"
                [placeholder]="'common.email' | transloco"
              />
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ playerForm.get('email')?.value || '—' }}
              </span>
            }
          </div>
          <!-- Phone Prefix -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'settings.profile.prefix' | transloco}}:</span>
            @if(editMode) {
              <input
                z-input
                formControlName="prefix"
                class="border rounded px-2 py-1 w-full text-sm bg-white"
                [placeholder]="'+1'"
              />
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ playerForm.get('prefix')?.value || '—' }}
              </span>
            }
          </div>
          
          <!-- Phone -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'common.phone' | transloco}}:</span>
            @if(editMode) {
              <input
                z-input
                formControlName="number"
                class="border rounded px-2 py-1 w-full text-sm bg-white"
                [placeholder]="'common.phone' | transloco"
              />
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ playerForm.get('number')?.value || '—' }}
              </span>
            }
          </div>
          <!-- City -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'common.city' | transloco}}:</span>
            @if(editMode) {
              <input
                z-input
                formControlName="city"
                class="border rounded px-2 py-1 w-full text-sm bg-white"
                [placeholder]="'common.city' | transloco"
              />
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ playerForm.get('city')?.value || '—' }}
              </span>
            }
          </div>
          <!-- Street -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'common.street' | transloco}}:</span>
            @if(editMode) {
              <input
                z-input
                formControlName="street"
                class="border rounded px-2 py-1 w-full text-sm bg-white"
                [placeholder]="'common.street' | transloco"
              />
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ playerForm.get('street')?.value || '—' }}
              </span>
            }
          </div>
          <!-- Postal Code -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'common.postalCode' | transloco}}:</span>
            @if(editMode) {
              <input
                z-input
                formControlName="postalCode"
                class="border rounded px-2 py-1 w-full text-sm bg-white"
                [placeholder]="'common.postalCode' | transloco"
              />
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ playerForm.get('postalCode')?.value || '—' }}
              </span>
            }
          </div>
          <!-- Username -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'common.username' | transloco }}:</span>
            @if(editMode) {
              <input
                z-input
                formControlName="username"
                class="border rounded px-2 py-1 w-full text-sm bg-white"
                [placeholder]="'common.username' | transloco"
              />
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ playerForm.get('username')?.value || '—' }}
              </span>
            }
          </div>
          <!-- Favourite Team -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'players.withdrawals.popup.favouriteTeam' | transloco }}:</span>
            @if(editMode) {
              <input
                z-input
                formControlName="favouriteTeam"
                class="border rounded px-2 py-1 w-full text-sm bg-white"
                [placeholder]="'players.withdrawals.popup.favouriteTeam' | transloco"
              />
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ playerForm.get('favouriteTeam')?.value || '—' }}
              </span>
            }
          </div>
          <!-- Promo Code -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'players.withdrawals.popup.promoCode' | transloco }}:</span>
            @if(editMode) {
              <input
                z-input
                formControlName="promoCode"
                class="border rounded px-2 py-1 w-full text-sm bg-white"
                [placeholder]="'players.withdrawals.popup.promoCode' | transloco"
              />
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ playerForm.get('promoCode')?.value || '—' }}
              </span>
            }
          </div>
        </div>
        </z-card>

        <z-card>
        <!-- Preferences Column -->
        <div class="flex flex-col flex-1">
          <div class="flex items-center mb-1">
            <div class="w-1 h-4 bg-gradient-to-b from-rose-500 to-rose-600 rounded-full mr-2"></div>
            <h3 class="text-[18px] font-bold text-slate-800 tracking-tight uppercase">
              {{ 'players.inner-tabs.social-preferences' | transloco }}
            </h3>
          </div>
          
          <!-- Email Verified -->
          <div class="mb-1 text-sm font-medium flex items-center justify-between">
            <span class="text-slate-600 text-[13px]">{{ 'players.withdrawals.popup.emailVerified' | transloco }}:</span>
            <span class="ml-2"><z-switch [disabled]="!editMode" formControlName="emailVerified"></z-switch></span>
          </div>
          
          <!-- Phone Verified -->
          <div class="mb-1 text-sm font-medium flex items-center justify-between">
            <span class="text-slate-600 text-[13px]">{{ 'players.withdrawals.popup.phoneNoVerified' | transloco }}:</span>
            <span class="ml-2"><z-switch [disabled]="!editMode" formControlName="phoneNoVerified"></z-switch></span>
          </div>
          
          <!-- Receive Offers -->
          <div class="mb-1 text-sm font-medium flex items-center justify-between">
            <span class="text-slate-600 text-[13px]">{{ 'players.withdrawals.popup.receiveOffers' | transloco }}:</span>
            <span class="ml-2"><z-switch [disabled]="!editMode" formControlName="receiveOfferAndBonuses"></z-switch></span>
          </div>
          
          <!-- Receive News -->
          <div class="mb-1 text-sm font-medium flex items-center justify-between">
            <span class="text-slate-600 text-[13px]">{{ 'players.withdrawals.popup.receiveNews' | transloco }}:</span>
            <span class="ml-2"><z-switch [disabled]="!editMode" formControlName="receiveNews"></z-switch></span>
          </div>
          
          <!-- Contact By Mail -->
          <div class="mb-1 text-sm font-medium flex items-center justify-between">
            <span class="text-slate-600 text-[13px]">{{ 'players.withdrawals.popup.contactByMail' | transloco }}:</span>
            <span class="ml-2"><z-switch [disabled]="!editMode" formControlName="contactByMail"></z-switch></span>
          </div>
          
          <!-- Contact By Phone -->
          <div class="mb-1 text-sm font-medium flex items-center justify-between">
            <span class="text-slate-600 text-[13px]">{{ 'players.withdrawals.popup.contactByPhone' | transloco }}:</span>
            <span class="ml-2"><z-switch [disabled]="!editMode" formControlName="contactByPhone"></z-switch></span>
          </div>
          
          <!-- Contact By SMS -->
          <div class="mb-1 text-sm font-medium flex items-center justify-between">
            <span class="text-slate-600 text-[13px]">{{ 'players.withdrawals.popup.contactBySms' | transloco }}:</span>
            <span class="ml-2"><z-switch [disabled]="!editMode" formControlName="contactBySms"></z-switch></span>
          </div>
          
          <!-- Two Factor Auth -->
          <div class="mb-1 text-sm font-medium flex items-center justify-between">
            <span class="text-slate-600 text-[13px]">{{ 'players.withdrawals.popup.twoFactorAuth' | transloco }}:</span>
            <span class="ml-2"><z-switch [disabled]="!editMode" formControlName="twoFactorAuth"></z-switch></span>
          </div>
          
          <!-- Two Factor Withdraw -->
          <div class="mb-1 text-sm font-medium flex items-center justify-between">
            <span class="text-slate-600 text-[13px]">{{ 'players.withdrawals.popup.twoFactorWithdraw' | transloco }}:</span>
            <span class="ml-2"><z-switch [disabled]="!editMode" formControlName="twoFactorWithdraw"></z-switch></span>
          </div>
          
          <!-- Important Note -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'players.withdrawals.popup.importantNote' | transloco }}:</span>
            @if(editMode) {
              <input
                z-input
                formControlName="importantNote"
                class="border rounded px-2 py-1 w-full text-sm bg-white"
                [placeholder]="'players.withdrawals.popup.importantNote' | transloco"
              />
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ playerForm.get('importantNote')?.value || '—' }}
              </span>
            }
          </div>
        </div>
        </z-card>

        <z-card>
        <!-- Gaming Performance Column -->
        <div class="flex items-center mb-2">
          <div class="w-1 h-4 bg-gradient-to-b from-indigo-500 to-indigo-600 rounded-full mr-2"></div>
          <h3 class="text-[14px] font-bold text-slate-800 tracking-tight uppercase">
            {{ 'players.withdrawals.kyc.gamingPerformance' | transloco }}
          </h3>
        </div>

        <div class="space-y-0.5">
          <!-- Casino Total Winnings -->
          <div class="flex justify-between text-[11px] py-0.5">
            <span class="text-slate-600">{{ 'players.withdrawals.kyc.casinoTotalWinnings' | transloco }}:</span>
            <span class="text-black font-semibold">{{ formatCurrency(casinoFinancialDetails?.totalWinnings) }}</span>
          </div>

          <!-- Casino Total Bonus -->
          <div class="flex justify-between text-[11px] py-0.5">
            <span class="text-slate-600">{{ 'players.withdrawals.kyc.casinoTotalBonus' | transloco }}:</span>
            <span class="text-black font-semibold">{{ formatCurrency(casinoFinancialDetails?.totalBonus) }}</span>
          </div>

          <!-- Sports Total Winnings -->
          <div class="flex justify-between text-[11px] py-0.5">
            <span class="text-slate-600">{{ 'players.withdrawals.kyc.sportsTotalWinnings' | transloco }}:</span>
            <span class="text-black font-semibold">{{ formatCurrency(sportsFinancialDetails?.totalWinnings) }}</span>
          </div>

          <!-- Sports Total Bets -->
          <div class="flex justify-between text-[11px] py-0.5">
            <span class="text-slate-600">{{ 'players.withdrawals.kyc.sportsTotalBets' | transloco }}:</span>
            <span class="text-black font-semibold">{{ sportsFinancialDetails?.totalBets != null ? sportsFinancialDetails.totalBets.toString() : '—' }}</span>
          </div>

          <!-- Sports Bonus -->
          <div class="flex justify-between text-[11px] py-0.5">
            <span class="text-slate-600">{{ 'players.withdrawals.kyc.sportsBonus' | transloco }}:</span>
            <span class="text-black font-semibold">{{ formatCurrency(sportsFinancialDetails?.bonus) }}</span>
          </div>

          <!-- VIP Points -->
          <div class="flex justify-between text-[11px] py-0.5">
            <span class="text-slate-600">{{ 'players.withdrawals.kyc.vipPoints' | transloco }}:</span>
            <span class="text-black font-semibold">—</span>
          </div>
            
          <!-- Casino Total Stakes -->
          <div class="flex justify-between text-[11px] py-0.5">
            <span class="text-slate-600">{{ 'players.withdrawals.kyc.casinoStakes' | transloco }}:</span>
            <span class="text-black font-semibold">{{ formatCurrency(casinoFinancialDetails?.totalStakes) }}</span>
          </div>
          
          <!-- Sport Total Stakes -->
          <div class="flex justify-between text-[11px] py-0.5">
            <span class="text-slate-600">{{ 'players.withdrawals.kyc.sportStakes' | transloco }}:</span>
            <span class="text-black font-semibold">{{ formatCurrency(sportsFinancialDetails?.totalStakes) }}</span>
          </div>
        </div>
        </z-card>

        

        <z-card>
        <!-- Player Performance Column -->
        <div class="flex items-center mb-2">
          <div class="w-1 h-4 bg-gradient-to-b from-amber-500 to-amber-600 rounded-full mr-2"></div>
          <h3 class="text-[14px] font-bold text-slate-800 tracking-tight uppercase">
            {{ 'players.withdrawals.kyc.playerPerformance' | transloco }}
          </h3>
        </div>
        
        <div class="space-y-0.5">
          <!-- Product -->
          <div class="flex justify-between text-[11px] py-0.5">
            <span class="text-slate-600">{{ 'players.register-sessions.product' | transloco }}:</span>
            <span class="text-black font-semibold">{{ getProductDisplay() }}</span>
          </div>

          <!-- Last Deposit Amount -->
          <div class="flex justify-between text-[11px] py-0.5">
            <span class="text-slate-600">{{ 'players.withdrawals.kyc.lastDepositAmount' | transloco }}:</span>
            <span class="text-black font-semibold">{{ formatCurrency(overallFinancialDetails?.lastDepositAmount) }}</span>
          </div>

          <!-- First Deposit Date -->
          <div class="flex justify-between text-[11px] py-0.5">
            <span class="text-slate-600">{{ 'players.withdrawals.kyc.firstDepositDate' | transloco }}:</span>
            <span class="text-black font-semibold">{{ overallFinancialDetails?.firstDepositDate ? formatDate(overallFinancialDetails.firstDepositDate) : '—' }}</span>
          </div>

          <!-- Last Deposit Date -->
          <div class="flex justify-between text-[11px] py-0.5">
            <span class="text-slate-600">{{ 'players.withdrawals.kyc.lastDepositDate' | transloco }}:</span>
            <span class="text-black font-semibold">{{ formatDate(overallFinancialDetails?.lastDepositDate) }}</span>
          </div>

          <!-- Withdrawal Amount -->
          <div class="flex justify-between text-[11px] py-0.5">
            <span class="text-slate-600">{{ 'players.withdrawals.kyc.withdrawalAmount' | transloco }}:</span>
            <span class="text-black font-semibold">{{ formatCurrency(overallFinancialDetails?.withdrawAmount) }}</span>
          </div>

          <!-- Withdrawal Count -->
          <div class="flex justify-between text-[11px] py-0.5">
            <span class="text-slate-600">{{ 'players.withdrawals.kyc.withdrawalCount' | transloco }}:</span>
            <span class="text-black font-semibold">{{ overallFinancialDetails?.withdrawalCount != null ? overallFinancialDetails.withdrawalCount.toString() : '—' }}</span>
          </div>

          <!-- Pending Withdrawals -->
          <div class="flex justify-between text-[11px] py-0.5">
            <span class="text-slate-600">{{ 'players.withdrawals.kyc.pendingWithdrawals' | transloco }}:</span>
            <span class="text-black font-semibold">—</span>
          </div>
            
          <!-- Wagered (Casino Stakes + Sport Stakes) -->
          <div class="flex justify-between text-[11px] py-0.5">
            <span class="text-slate-600">{{ 'players.withdrawals.kyc.wagered' | transloco }}:</span>
            <span class="text-black font-semibold">{{ ((casinoFinancialDetails?.totalStakes || 0) + (sportsFinancialDetails?.totalStakes || 0)) | currency:'USD':'symbol':'1.2-2' }}</span>
          </div>

          <!-- Total Deposits -->
          <div class="flex justify-between text-[11px] py-0.5">
            <span class="text-slate-600">{{ 'players.withdrawals.kyc.totalDeposits' | transloco }}:</span>
            <span class="text-black font-semibold">{{ financial_details?.overallFinancialDetails?.depositAmount !== null && financial_details?.overallFinancialDetails?.depositAmount !== undefined ? (financial_details.overallFinancialDetails.depositAmount + '$') : '—' }}</span>
          </div>

          <!-- Total Withdrawals -->
          <div class="flex justify-between text-[11px] py-0.5">
            <span class="text-slate-600">{{ 'players.withdrawals.kyc.totalWithdrawals' | transloco }}:</span>
            <span class="text-black font-semibold">{{ financial_details?.overallFinancialDetails?.withdrawAmount !== null && financial_details?.overallFinancialDetails?.withdrawAmount !== undefined ? (financial_details.overallFinancialDetails.withdrawAmount + '$') : '—' }}</span>
          </div>
        </div>
        </z-card>  

        <!-- General Data Column -->
        <z-card>
        <div class="flex flex-col flex-1">
          <!-- General Data -->
          <div class="flex items-center mb-1">
            <div class="w-1 h-4 bg-gradient-to-b from-cyan-500 to-cyan-600 rounded-full mr-2"></div>
            <h3 class="text-[18px] font-bold text-slate-800 tracking-tight uppercase">
              {{ 'players.documents.general_data.title' | transloco }}
            </h3>
          </div>
          
          <!-- Account Verified -->
          <div class="mb-1 text-sm font-medium flex items-center justify-between">
            <span class="text-slate-600 text-[13px]">{{ 'players.documents.general_data.account_verified' | transloco }}:</span>
            <span class="ml-2"><z-switch [disabled]="!editMode" formControlName="accountVerified"></z-switch></span>
          </div>
          
          <!-- Verification Status -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'players.documents.general_data.verification_status' | transloco }}:</span>
            @if(editMode) {
              <z-select formControlName="verificationStatus" class="w-full" size="sm">
                <z-select-item value="PENDING">{{ 'players.documents.general_data.verification_statuses.PENDING' | transloco }}</z-select-item>
                <z-select-item value="REJECTED">{{ 'players.documents.general_data.verification_statuses.REJECTED' | transloco }}</z-select-item>
                <z-select-item value="VERIFIED">{{ 'players.documents.general_data.verification_statuses.VERIFIED' | transloco }}</z-select-item>
                <z-select-item value="INPUT_COMPLETED">{{ 'players.documents.general_data.verification_statuses.INPUT_COMPLETED' | transloco }}</z-select-item>
              </z-select>
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ getVerificationStatusDisplay() }}
              </span>
            }
          </div>
          
          <!-- Bonus Allowed -->
          <div class="mb-1 text-sm font-medium flex items-center justify-between">
            <span class="text-slate-600 text-[13px]">{{ 'players.documents.general_data.bonus_allowed' | transloco }}:</span>
            <span class="ml-2"><z-switch [disabled]="!editMode" formControlName="bonusAllowed"></z-switch></span>
          </div>
          
          <!-- Withdraw Allowed -->
          <div class="mb-1 text-sm font-medium flex items-center justify-between">
            <span class="text-slate-600 text-[13px]">{{ 'players.documents.general_data.withdraw_allowed' | transloco }}:</span>
            <span class="ml-2"><z-switch [disabled]="!editMode" formControlName="withdrawalAllowed"></z-switch></span>
          </div>
          
          <!-- Language -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'players.documents.general_data.language' | transloco }}:</span>
            @if(editMode) {
              <z-select formControlName="language" class="w-full" size="sm">
                <z-select-item value="ENGLISH">{{ 'players.documents.general_data.languages.ENGLISH' | transloco }}</z-select-item>
                <z-select-item value="SPANISH_MEXICO">{{ 'players.documents.general_data.languages.SPANISH_MEXICO' | transloco }}</z-select-item>
              </z-select>
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ getLanguageDisplay() }}
              </span>
            }
          </div>
          
          <!-- Account Status -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'players.documents.general_data.account_status' | transloco }}:</span>
            <span class="text-black font-semibold ml-1 text-[13px]">
              {{ player?.accountStatus || '—' }}
            </span>
          </div>
          
          <!-- VIP Level -->
          <div class="mb-1 text-sm font-medium">
            <span class="text-slate-600 text-[13px]">{{ 'players.documents.general_data.vip_level' | transloco }}:</span>
            @if(editMode) {
              <z-select formControlName="vipLevel" class="w-full" size="sm">
                <z-select-item value="LEVEL_0">{{ 'players.documents.general_data.vip_levels.LEVEL_0' | transloco }}</z-select-item>
                <z-select-item value="LEVEL_1">{{ 'players.documents.general_data.vip_levels.LEVEL_1' | transloco }}</z-select-item>
                <z-select-item value="LEVEL_2">{{ 'players.documents.general_data.vip_levels.LEVEL_2' | transloco }}</z-select-item>
                <z-select-item value="LEVEL_3">{{ 'players.documents.general_data.vip_levels.LEVEL_3' | transloco }}</z-select-item>
                <z-select-item value="LEVEL_4">{{ 'players.documents.general_data.vip_levels.LEVEL_4' | transloco }}</z-select-item>
                <z-select-item value="LEVEL_5">{{ 'players.documents.general_data.vip_levels.LEVEL_5' | transloco }}</z-select-item>
                <z-select-item value="LEVEL_6">{{ 'players.documents.general_data.vip_levels.LEVEL_6' | transloco }}</z-select-item>
              </z-select>
            } @else {
              <span class="text-black font-semibold ml-1 text-[13px]">
                {{ getVipLevelDisplay() }}
              </span>
            }
          </div>
        </div>
        </z-card>

      </form>

      <!-- Financial Balances Row - Full Width -->
      <div class="w-full px-2 md:px-4 py-2 mt-2 border-t border-slate-200/60 bg-slate-50/30 rounded-b-2xl">
        <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-2 md:gap-4">
          <!-- Title in first column -->
          <div class="col-span-2 sm:col-span-1 flex items-center p-2 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border-2 border-green-200 shadow-md">
            <div class="w-1 h-4 bg-gradient-to-b from-green-500 to-green-600 rounded-full mr-2"></div>
            <h3 class="text-[14px] font-bold text-green-800 tracking-tight uppercase">
              {{ 'players.documents.financial_balances.title' | transloco }}
            </h3>
          </div>
          
          <!-- Balance -->
          <div class="text-sm font-medium p-2 bg-white/60 rounded-lg border border-slate-200/40 shadow-sm">
            <span class="text-slate-600 block mb-1 text-[11px]">{{ 'players.documents.financial_balances.balance' | transloco }}:</span>
            <span class="text-black font-semibold">
              {{ formatCurrency(financial_details?.overallFinancialDetails?.balance) }}
            </span>
          </div>
          
          <!-- Total Balance -->
          <div class="text-sm font-medium p-2 bg-white/60 rounded-lg border border-slate-200/40 shadow-sm">
            <span class="text-slate-600 block mb-1 text-[11px]">{{ 'players.documents.financial_balances.total_balance' | transloco }}:</span>
            <span class="text-black font-semibold">
              {{ formatCurrency(financial_details?.overallFinancialDetails?.totalBalance) }}
            </span>
          </div>
          
          <!-- Sport Bonus Balance -->
          <div class="text-sm font-medium p-2 bg-white/60 rounded-lg border border-slate-200/40 shadow-sm">
            <span class="text-slate-600 block mb-1 text-[11px]">{{ 'players.documents.financial_balances.sport_bonus_balance' | transloco }}:</span>
            <span class="text-black font-semibold">
              {{ formatCurrency(financial_details?.overallFinancialDetails?.sportBonusBalance) }}
            </span>
          </div>
          
          <!-- Casino Bonus Balance -->
          <div class="text-sm font-medium p-2 bg-white/60 rounded-lg border border-slate-200/40 shadow-sm">
            <span class="text-slate-600 block mb-1 text-[11px]">{{ 'players.documents.financial_balances.casino_bonus_balance' | transloco }}:</span>
            <span class="text-black font-semibold">
              {{ formatCurrency(financial_details?.overallFinancialDetails?.casinoBonusBalance) }}
            </span>
          </div>
          
          <!-- Last Bonus Date -->
          <div class="text-sm font-medium p-2 bg-white/60 rounded-lg border border-slate-200/40 shadow-sm">
            <span class="text-slate-600 block mb-1 text-[11px]">{{ 'players.documents.financial_balances.last_bonus_date' | transloco }}:</span>
            <span class="text-black font-semibold">
              {{ formatDate(financial_details?.overallFinancialDetails?.lastBonusDate) }}
            </span>
          </div>
          
          <!-- Last Bonus Amount -->
          <div class="text-sm font-medium p-2 bg-white/60 rounded-lg border border-slate-200/40 shadow-sm">
            <span class="text-slate-600 block mb-1 text-[11px]">{{ 'players.documents.financial_balances.last_bonus_amount' | transloco }}:</span>
            <span class="text-black font-semibold">
              {{ formatCurrency(financial_details?.overallFinancialDetails?.lastBonusAmount) }}
            </span>
          </div>
          
          <!-- Total Bonus Given -->
          <div class="text-sm font-medium p-2 bg-white/60 rounded-lg border border-slate-200/40 shadow-sm">
            <span class="text-slate-600 block mb-1 text-[11px]">{{ 'players.documents.financial_balances.total_bonus_given' | transloco }}:</span>
            <span class="text-black font-semibold">
              {{ formatCurrency(financial_details?.overallFinancialDetails?.totalBonusGiven) }}
            </span>
          </div>
          
        </div>
      </div>
    }
  </div>
</div> 